export enum MainDistributionUndergroundReason {
  Irregular,
  Monument,
  Glass,
  Gable,
  Height,
  Ornamental,
  NotApplicable,
}
